module.exports = __webpack_public_path__ + "img/09.60d9fa55.jpg";